import service from '../index'
import config from '@/assets/config.json'


/**
 * @亲子项目核销管理
 * 
 * @config.babyHttps.api 
 */

 const token = localStorage.getItem('Beitoken')

// 获取核销记录列表
export function getWriteOffList(params) {
    const url = config.babyHttps.api + '/apitravel/write/off-list';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

// 查询核销详情
export function getWriteOffDetail(params) {
    const url = config.babyHttps.api + '/apitravel/write/detail';
    return service({
        method: 'get',
        url,
        params,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

// 核销（单条或多条，不包括批量核销，批量核销需要文件上传）
export function writeOff (data) {
    const url = config.babyHttps.api + '/apitravel/write/volume-code';
    return service({
        method: 'post',
        url,
        data,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}

// 批量核销文件上传
export function uploadWrite (data) {
    const url = config.babyHttps.api + '/apitravel/write/uploadFile';
    return service({
        method: 'post',
        url,
        data,
        headers: {
            Authorization:'Bearer ' + token
        }
    })
}